/* ========== ~~~~~~~~~~ APP STATUS : ACTIONS ~~~~~~~~~~ ========== */
// ACTION
// utilized by reducers as a call to action to perform some kind of update to application state
// utilized in "_container" components and reducers



/* ++++++++++ --------------- IMPORTS --------------- ++++++++++ */
// import { push } from 'react-router-redux';



/* ++++++++++ --------------- EXPORTS --------------- ++++++++++ */
export const DISPLAY_MODAL = 'DISPLAY_MODAL';

export const displayModal = (isVisible, contentToDisplay, showCloseButton) => ({
    type: DISPLAY_MODAL,
    isVisible,
    contentToDisplay,
    showCloseButton
});